import { ResourceClient } from '@resourceful-hono/core';
import type { AssertionResource } from '../../index.ts';

export class AssertionResourceClient extends ResourceClient<AssertionResource> {
  constructor(resource: typeof AssertionResource, origin?: string) {
    super(resource, origin);
  }

  public readonly assert = async (email: string) => {
    const assertionOptions = await this.put(email);
    const credential = await navigator.credentials.get(assertionOptions);
    if (!(credential instanceof PublicKeyCredential))
      throw Error('Investigate further', { cause: credential });
    const assertionResponse =
      credential.response as AuthenticatorAssertionResponse;
    return await this.post({
      rawId: new Uint8Array(credential.rawId),
      response: {
        clientDataJSON: new Uint8Array(assertionResponse.clientDataJSON),
        authenticatorData: new Uint8Array(assertionResponse.authenticatorData),
        signature: new Uint8Array(assertionResponse.signature),
      },
    });
  };
}